import React from 'react';
import { Textarea } from '@gafe/common-ui';

import { useOrderContext } from '@/components/modals/SubmitOrder/helpers';
import { OrderDeliveryType } from '@/types';
import { formatPhoneNumber } from '@/utils/format-phone-number';

import { ProposalBlockWrapper } from '../../../Common/ProposalBlockWrapper';

import { Props } from './types';

import styles from '../../ConfirmationStep.module.scss';

export const ConfirmationShippingDetails = ({ goToStep }: Props) => {
  const state = useOrderContext();
  const isActivityDistributionModel = state.isDistribution;

  const shippingAddressTitle =
    state.order.deliveryType === OrderDeliveryType['Company/warehouse address']
      ? 'Warehouse'
      : `${state.order.shipmentContact?.firstName} ${state.order.shipmentContact?.lastName}`;

  if (isActivityDistributionModel) {
    return null;
  }

  return (
    <ProposalBlockWrapper
      link={{
        label: 'Edit Shipping',
        click: goToStep,
      }}
      title="Shipping Details"
    >
      <div className={styles.shipping_wrapper}>
        {state.order.shipmentContact?.isDefault && (
          <div className={styles.default_label}>Default</div>
        )}
        <div className={styles.shipping_info_wrapper}>
          <div className={styles.shipping_info}>
            <div className={styles.shipping_info_title}>{shippingAddressTitle}</div>
            <div className={styles.shipping_info_text}>
              <span className={styles.bold_text}>Phone:</span>{' '}
              {formatPhoneNumber(state.order.shipmentContact?.phoneNumber)}
            </div>
            <div className={styles.shipping_info_text} style={{ marginBottom: 10 }}>
              <span className={styles.bold_text}>Email:</span> {state.order.shipmentContact?.email}
            </div>
            <div className={styles.shipping_info_text}>
              {state.order.shipmentContact?.addressLine1}{' '}
              {state.order.shipmentContact?.addressLine2} {state.order.shipmentContact?.city},{' '}
              {state.order.shipmentContact?.state} {state.order.shipmentContact?.zipCode}
            </div>
          </div>
          <div className={styles.shipping_comments}>
            <Textarea
              disabled
              label="Add Comments"
              name="prospectNotes"
              placeholder="-"
              value={state.order.deliveryInstruction ?? '-'}
            />
          </div>
        </div>
      </div>
    </ProposalBlockWrapper>
  );
};
